// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__X0IPo","header":"MergedInvoice_header__1Fhi9"};